import { MerchantModel } from "@/model/merchant/merchantModel";
import { UserModel } from "@/model/user/userModel";

function GetMerchantsList(merchantsList: any): Array<MerchantModel> {
  const merchantsListModel = new Array<MerchantModel>();
  if (merchantsList && merchantsList.length > 0) {
    merchantsList.forEach((merchant: any) => {
      merchantsListModel.push(merchant);
    });
  }

  return merchantsListModel;
}

export function ConvertToUserModel(userInfo: any): UserModel {
  /* eslint-disable @typescript-eslint/camelcase */
  const userModel: UserModel = {
    userId: userInfo.id,
    displayName: userInfo.given_name,
    lastLogInDateTime: userInfo.lastLogInDateTime,
    registerDateTime: userInfo.registerDateTime,
    phone: userInfo.phone_number,
    pictureUrl: userInfo.picture,
    signatureUrl: userInfo.signatureUrl,
  };

  return userModel;
}
